@if (keg) {
  <ion-item lines="full" routerLink="/inventory/kegs/details/{{ keg.id }}">
    <ion-thumbnail slot="end">
      @if (keg.container === 'PubKeg' || !keg.container) {
        <app-keg-svg
          [item]="keg"
        ></app-keg-svg>
      }
      @if (keg.container === 'CornyKeg') {
        <app-cornykeg-svg
          [item]="keg"
        ></app-cornykeg-svg>
      }
      @if (keg.container === 'CornyKeg12') {
        <app-cornykeg12-svg
          [item]="keg"
        ></app-cornykeg12-svg>
      }
      @if (keg.container === 'CornyKeg09') {
        <app-cornykeg09-svg
          [item]="keg"
        ></app-cornykeg09-svg>
      }
    </ion-thumbnail>
    @if (beverage?.image) {
      <ion-thumbnail slot="end">
        <img [src]="beverage?.image" />
      </ion-thumbnail>
    }
    <ion-label>
      {{ keg.name }}
      @if (!!beverage) {
        <div>
          <ion-text class="color-medium">{{ beverage.name }}</ion-text>
        </div>
      }
      <div class="ps-badge-list">
        @if (unitTypes()) {
          <ion-badge>
            Size:  {{
            unitsHelper.toUnit(keg.size, "l", unitTypes()?.kegs ?? '', -1)
            | number : "1.2-2"
            }}
            {{ unitTypes()?.kegs }}
          </ion-badge>
        }
        @if (unitTypes()) {
          <ion-badge>
            Amount left:  {{
            unitsHelper.toUnit(keg.size, "l", unitTypes()?.kegs ?? '', -1)
            | number : "1.2-2"
            }}
            {{ unitTypes()?.kegs }}
          </ion-badge>
        }
        @if (keg.notificationDate) {
          <ion-badge
      [color]="{
        'danger': dateHelper.lessThanOrEqualTo(
          keg.notificationDate,
          today
        )
      }"
            >
            <ion-icon name="notifications-outline"></ion-icon>
            Notification: {{ dateHelper.calendar(keg.notificationDate) }}
          </ion-badge>
        }
        @if (keg.bestBeforeDate) {
          <ion-badge
      [color]="{
        'danger': dateHelper.lessThanOrEqualTo(
          keg.bestBeforeDate,
          today
        )
      }"
            >
            <ion-icon name="calendar-clear-outline"></ion-icon>
            BBF:
            {{ dateHelper.formatDate(keg.bestBeforeDate, "MMMM yyyy") }}
          </ion-badge>
        }
      </div>
    </ion-label>
  </ion-item>
}
